module.exports = __webpack_public_path__ + "img/person.6c1a000.svg";